// MyContextProvider.js
import React, { useState } from "react";
import MyContext from "./Mycontext";

const MyContextProvider = ({ children }) => {
  // Your shared data and state
  const [randValue, setRandValue] = useState(0);

  return (
    <MyContext.Provider value={{ randValue, setRandValue }}>
      {children}
    </MyContext.Provider>
  );
};

export default MyContextProvider;
